import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GiFinSimulacaoFinanciadoraModel } from "../../../dominio/gi-fin-simulacao-financiadora-model";
import { GiFinSituacaoModel } from "../../../dominio/gi-fin-situacao-model";
import { NotificacaoService } from "../../../services/notificacao.service";
import { AlterarSituacaoFinanciadoraRequest, FinSimulacaoService } from "../../../services/fin-simulacao.service";
import { CarregandoService } from "../../../services/carregando.service";
import { QueryFilterService } from "../../../core/services/query-filter-service";
import { FinSimulacaoFinanciadoraStatus } from "../../../dominio/enums";

@Component({
  selector: 'app-alterar-situacao-financiadora-modal',
  templateUrl: './alterar-situacao-financiadora-modal.component.html',
  styleUrls: ['./alterar-situacao-financiadora-modal.component.scss']
})
export class AlterarSituacaoFinanciadoraModalComponent implements OnInit {
  finSimulacao: GiFinSimulacaoFinanciadoraModel;
  listaStatus: GiFinSituacaoModel[] = [];
  idTarefa: number;
  statusAtual: FinSimulacaoFinanciadoraStatus;

  constructor(
    private dialogRef: MatDialogRef<AlterarSituacaoFinanciadoraModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private finSimulacaoService: FinSimulacaoService,
    private carregandoService: CarregandoService,
    private queryFilterService: QueryFilterService,
  ) {
    this.idTarefa = data.idTarefa;
    this.finSimulacao = data.finSimulacao;
    this.statusAtual = this.finSimulacao.sumario != null ? this.finSimulacao.sumario.status : null;
  }

  async ngOnInit() {
    this.buscarListaStatus().then();
  }

  async buscarListaStatus() {
    try {
      this.carregandoService.mostra('buscarListaStatus');
      const queryFilter = this.queryFilterService.getQueryBuilder()
        .addCondition("tipoSituacao", "=", 1)
        .build();

      this.listaStatus = (await this.finSimulacaoService.buscarListaStatus(queryFilter).toPromise()).results;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarListaStatus');
    }
  }

  alterar() {
    this.carregandoService.mostra('alterar');

    const request: AlterarSituacaoFinanciadoraRequest = {
      situacao: this.finSimulacao.sumario.status
    };

    this.finSimulacaoService.alterarSituacaoFinanciadora(this.idTarefa, this.finSimulacao.id, request).subscribe(data => {
      this.notificacaoService.sucesso("Situação alterada com sucesso!");
      this.carregandoService.esconde('alterar');
      this.fechar(true);
    }, (erro) => {
      this.carregandoService.esconde('alterar');
      this.notificacaoService.erro(erro);
      this.fechar();
    });
  }

  fechar(atualizar: boolean = false) {
    this.dialogRef.close(atualizar);
  }
}
